// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { EmojiPicker as Core, useSkinTone, } from 'frimousse';
import { withClassName, withProps } from '../../hooks.js';
import { useLocalStorage } from '../../hooks/useStorage.js';
import { Box } from '../box/Box.js';
import { Button } from '../button/Button.js';
import { inputClassName } from '../input/Input.js';
import { Spinner } from '../spinner/Spinner.js';
export const EmojiPickerRoot = withClassName(Core.Root, 'layer-components:isolate layer-components:flex layer-components:flex-col layer-components:w-fit layer-components:h-368px layer-components:gap-sm');
export const EmojiPickerSearch = withClassName(Core.Search, 'layer-components:z-10', inputClassName);
export const EmojiPickerViewport = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx(Box, { className: "flex-1 min-h-0 overflow-hidden rounded-md bg-white", children: _jsx(Core.Viewport, Object.assign({ className: "layer-components:relative layer-components:outline-hidden" }, props)) }));
};
export const EmojiPickerLoading = withClassName(withProps(Core.Loading, {
    children: _jsx(Spinner, {}),
}), 'layer-compoennts:absolute layer-compoennts:inset-0 layer-compoennts:flex layer-compoennts:items-center layer-compoennts:justify-center layer-compoennts:bg-inherit');
export const EmojiPickerEmpty = withClassName(withProps(Core.Empty, {
    children: _jsx(_Fragment, { children: "No emoji found" }),
}), 'layer-components:absolute layer-components:inset-0 layer-components:flex layer-components:items-center layer-components:justify-center layer-components:bg-inherit layer-components:color-gray-dark layer-components:text-xs');
export const EmojiPickerCategoryHeader = (props) => (_jsx("div", { className: clsx('layer-components:bg-inherit layer-components:px-md layer-components:py-sm layer-components:text-xs layer-components:font-semibold layer-components:text-gray-dark layer-components:sticky layer-components:top-0', props.className), children: props.category.label }));
export const EmojiPickerRow = withClassName('div', 'layer-components:scroll-my-xs layer-components:px-xs');
export const EmojiPickerEmoji = withClassName((p) => (_jsx(Button, Object.assign({}, p, { color: "ghost", toggled: p.emoji.isActive, toggleMode: "color", size: "icon-small", "aria-label": p.emoji.label, className: "text-lg p-xs", children: p.emoji.emoji }))), '');
const defaultListComponents = {
    CategoryHeader: EmojiPickerCategoryHeader,
    Row: EmojiPickerRow,
    Emoji: EmojiPickerEmoji,
};
export const EmojiPickerList = ({ className, components, }) => {
    return (_jsx(Core.List, { className: clsx('layer-components:select-none layer-components:pb-md', className), components: components
            ? Object.assign(Object.assign({}, defaultListComponents), components) : defaultListComponents }));
};
export const useEmojiSkinTone = () => useLocalStorage('emoji-skin-tone', undefined, false);
export const EmojiPickerSkinToneSelector = (props) => {
    const [_, __, options] = useSkinTone();
    const [skinTone, setSkinTone] = useEmojiSkinTone();
    return (_jsx(Box, Object.assign({ d: "row", gap: true }, props, { children: options.map((option) => (_jsx(Button, { color: "ghost", toggled: option.skinTone === skinTone, toggleMode: "color", size: "icon-small", "aria-label": `Skin tone ${option}`, className: "text-md p-xs", onClick: () => setSkinTone(option.skinTone), children: option.emoji }, option.skinTone))) })));
};
const EmojiPickerPrefab = (_a) => {
    var { onValueChange } = _a, props = __rest(_a, ["onValueChange"]);
    const [skinTone] = useEmojiSkinTone();
    return (_jsxs(EmojiPickerRoot, Object.assign({}, props, { onEmojiSelect: (emoji) => onValueChange(emoji.emoji, emoji.label), skinTone: skinTone, children: [_jsx(EmojiPickerSearch, {}), _jsxs(EmojiPickerViewport, { children: [_jsx(EmojiPickerList, {}), _jsx(EmojiPickerLoading, {}), _jsx(EmojiPickerEmpty, {})] }), _jsx(EmojiPickerSkinToneSelector, { className: "mr-auto" })] })));
};
export const EmojiPicker = Object.assign(EmojiPickerPrefab, {
    Root: EmojiPickerRoot,
    Search: EmojiPickerSearch,
    Viewport: EmojiPickerViewport,
    List: EmojiPickerList,
    Loading: EmojiPickerLoading,
    Empty: EmojiPickerEmpty,
    CategoryHeader: EmojiPickerCategoryHeader,
    Row: EmojiPickerRow,
    Emoji: EmojiPickerEmoji,
});
//# sourceMappingURL=EmojiPicker.js.map